import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter, Routes, Route } from "react-router";

import Search from './Search.jsx'
import NavBar from './Menus.jsx'
import AddEntry from './Forms.jsx'
import About from './About.jsx'
import NotFound from './NotFound.jsx'

import { initFlowbite } from 'flowbite';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

// Required for chrome, import flowbite didn't work.
// Also required on every page move to fix tooltip not working
function FlowbiteInit() {
  const location = useLocation();
  
  useEffect(() => {
    initFlowbite();
  }, [location.pathname]); // Re-run when route changes
  
  return null;
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <FlowbiteInit />
      <NavBar />
      <div className="xl:ml-64 pt-20 pb-20 xl:pt-40 xl:pb-40 min-h-screen min-w-[315px] text-xs md:text-base">
        <Routes>
          <Route path="/" element={<Search />} />
          {(import.meta.env.DEV) &&
            <Route path="/entry/add" element={<AddEntry />} />
          }
          <Route path="/about" element={<About />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </BrowserRouter>
  </StrictMode>
);